export class ArticleTypeDto {
    id!: number;
    name!: string;
}
